import { render, staticRenderFns } from "./SoundRightsAssignmentEditor.vue?vue&type=template&id=664ff1fc&scoped=true"
import script from "./SoundRightsAssignmentEditor.vue?vue&type=script&lang=js"
export * from "./SoundRightsAssignmentEditor.vue?vue&type=script&lang=js"
import style0 from "./SoundRightsAssignmentEditor.vue?vue&type=style&index=0&id=664ff1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ff1fc",
  null
  
)

export default component.exports